import "../scss/style.scss";
import "./splide_setting.js"
import "./splide-extension-auto-scroll.min.js"
import $ from 'jquery';
import "./lity.js"
import "./animation.js"
import "./movie.js"
import "./index.js"
